import request from '@/utils/request'

const url = '/home/invoicing/'
const api = {
  getInvoicingList (data) {
    return request({
      url: url + 'getInvoicingList',
      method: 'post',
      data
    })
  },
  importInvoicing (data) {
    return request({
      url: url + 'importInvoicing',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'handleDelete',
      method: 'post',
      data
    })
  },
  saveInvoicing (data) {
    return request({
      url: url + 'saveInvoicing',
      method: 'post',
      data
    })
  },
  export (data) {
    return request({
      url: url + 'export',
      method: 'post',
      data
    })
  },
  changeis_return_money (data) {
    return request({
      url: url + 'changeis_return_money',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/invoicing.js